<template>
  <div :class="$store.state.app.language_position == 'header' && $store.state.app.view_pattern === 'mb' ? '' : 'jz_web_col basic_language'">
    <div class="tooptipPart module_edit_btn" style="top: 0 !important" v-if="$store.state.app.view_pattern === 'pc'">
        <my_edit_btn :module="module" :title="$t('widgets_basic_language_index_2553')"></my_edit_btn>
        <my_moduleShow_btn radioName="multiLanguageOpen" :title="$t('widgets_basic_language_index_2554')"></my_moduleShow_btn>
    </div>
    <div class="s_multi_language_wrap" :class="listArr.styleType">
      <div class="languages languages_dropdown"
      :class="listArr.navigationItems == 'icon' ? 'no_text': ''">
        <!-- 下拉式 -->
          <span class="languages_default_item"
          @click="clickOpenDialog"
          v-if="$store.state.app.view_pattern === 'pc' && listArr.styleType !== 'expansion'">
            <p class="s_multi_language_icon" :class="selectLang.value"
            v-if="listArr.navigationItems == 'all' || listArr.navigationItems == 'icon'"></p>
            <span class="s_multi_language_text"
            v-if="listArr.navigationItems == 'all' || listArr.navigationItems == 'word'" 
            :style="[se_text_style,{
              display: 'none'
            }]">
             {{selectLang.label}}
            </span>
            <i class="arrow iconfont icon-jiantou s_multi_language_dropdown_svg" 
            v-if="listArr.styleType == 'dropdown' && $store.state.app.language_position == 'header'"></i>
          </span>
            <ul class="languages_dropdown_panel"
            :style="[{
              marginLeft: $store.state.app.language_position == 'header' && $store.state.myRender.common.mb_header_nav_position == 'right' && $store.state.app.view_pattern === 'mb' ? '-15px !important' : '',
              left: $store.state.app.language_position == 'header' && $store.state.myRender.common.mb_header_nav_position == 'right' && $store.state.app.view_pattern === 'mb' ? '15px !important' : '',
              right: $store.state.app.language_position == 'header' && $store.state.myRender.common.mb_header_nav_position == 'right' && $store.state.app.view_pattern === 'mb' ? 'auto !important' : '',
              background: background
            }]"
            :class="$store.state.app.language_position == 'footer' ? 'bottom' : 'top'">
              <div class="dropdown_panel_triangle" :style="[{
                left: $store.state.app.language_position == 'header' && $store.state.myRender.common.mb_header_nav_position == 'right' && $store.state.app.view_pattern === 'mb' ? '30px !important' : '',
                right: $store.state.app.language_position == 'header' && $store.state.myRender.common.mb_header_nav_position == 'right' && $store.state.app.view_pattern === 'mb' ? 'auto !important' : '',
                '--background': background
              }]"></div>
              <div class="languages_dropdown_content">
                <li class="language_item languages_dropdown_item" v-for="(lang,index) in langsList" :key="index" @click="seLang" v-show="!lang.is_hidden">
                  <a class="language_item_wrapper" hidefocus="true" href="#">
                    <p class="s_multi_language_icon"
                      :class="lang.value"
                      v-if="listArr.navigationItems == 'all' || listArr.navigationItems == 'icon'"></p>
                    <span class="s_multi_language_text"
                    v-if="listArr.navigationItems == 'all' || listArr.navigationItems == 'word'" 
                    :style="selectLang.value === lang.value ? se_text_style : text_style">{{lang.label}}</span>
                  </a>
                </li>
              </div>
          </ul>
        <!-- 横向 -->
        <template v-if="listArr.styleType == 'expansion' && $store.state.app.view_pattern == 'pc'">
          <ul class="languages languages_expansion" :style="{background: background}">
              <li class="language_item" v-for="(lang,index) in langsList" :key="index" @click="seLang" v-show="!lang.is_hidden">
                <a class="language_item_wrapper" hidefocus="true" href="#">
                  <p class="s_multi_language_icon" :class="lang.value"
                  v-if="listArr.navigationItems == 'all' || listArr.navigationItems == 'icon'"></p>
                  <span class="s_multi_language_text"
                  v-if="listArr.navigationItems == 'all' || listArr.navigationItems == 'word'"
                  :style="selectLang.value === lang.value ? se_text_style : text_style">{{lang.label}}</span>
                  <div class="language_item_after"></div>
                </a>
              </li>
          </ul>
        </template>
        <!-- 弹框 -->
        <template v-if="listArr.styleType == 'pop'">
          <div class="c_popup" v-if="pcPop_isShow">
            <div class="c_popup_layout" @click="pcPop_isShow=false"></div>
            <div class="c_popup_main" :style="{background: background}">
                <div class="c_popup_content">
                  <div class="multi_language_panel">
                      <div class="lan_title" :style="text_style">{{$t('widgets_basic_language_index_2555')}}</div>
                      <div class="lan_container">
                          <ul class="lan_lists">
                            <li class="lan_list" v-for="(lang,index) in langsList" :key="index" @click="seLang" v-show="!lang.is_hidden">
                                <a hidefocus="true" href="#" class="language_item_wrapper">
                                  <p :class="lang.value" class="s_multi_language_icon"></p>
                                  <span class="s_multi_language_text" :style="selectLang.value === lang.value ? se_text_style : text_style">{{lang.label}}</span>
                                </a>
                            </li>
                          </ul>
                      </div>
						      </div>
                </div>
             <i class="c_popup_close el-icon-close" @click="pcPop_isShow=false"></i>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!-- 手机弹框样式 -->
    <svg v-if="$store.state.app.view_pattern === 'mb' && $store.state.app.language_position == 'header'" @click="clickMbHeaderDialog" class="mb_icon"
    :style="{
      color: iconColor ? iconColor : theme_color,
      left: $store.state.myRender.common.mb_header_nav_position == 'left' ? 'auto' : '20px',
      right: $store.state.myRender.common.mb_header_nav_position == 'left' ? '20px' : 'auto',
    }">
      <use :xlink:href="`../../../static/image/langs2.svg`"></use>
    </svg>

    <!-- <img v-if="$store.state.app.view_pattern === 'mb' && $store.state.app.language_position == 'header'" class="mb_icon" 
    src="../../../static/image/langs1.svg"
    :style="{
      left: $store.state.myRender.common.mb_header_nav_position == 'left' ? 'auto' : '20px',
      right: $store.state.myRender.common.mb_header_nav_position == 'left' ? '20px' : 'auto',
    }"
     @click="clickMbHeaderDialog"> -->

    <div class="multi_Language_mobi_panel lan_active" v-if="mbPop_isShow">
      <div class="lan_layout" @click="mbPop_isShow=false"></div>
      <ul class="lan_mobi_lists" :style="{background: background}">
        <li class="lan_mobi_list" v-for="(lang,index) in langsList" :key="index" @click="seLang">
          <a hidefocus="true" href="#" class="language_item_wrapper">
            <p class="s_multi_language_icon" :class="lang.value"></p>
            <span class="s_multi_language_text"
            :style="selectLang.value === lang.value ? se_text_style : text_style">{{lang.label}}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import {
getLangNavList
} from "@/api/app";
import {basic_language_new_style} from "@/base/widgets_data_compatible";
import {throttle} from '@/base/base'
export default {
  name: 'basic_language',
  data() {
    return {
      mbPop_isShow: false,
      pcPop_isShow: false,
      dropdown_isShow: false,
      openLangList: [],
      langsList: [],
      selectLang: {
        label: '',
        value: '',
        img: ''
      }
    };
  },

  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    iconColor: {
      type: String,
      default: ''
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    background() {
      let infor = this.module.data.pc_widgets_infor
      const background =
        infor.background[infor.background.radio_val].pattern == 'linear_gradient'
          ? 'linear-gradient(' +
            infor.background[infor.background.radio_val].linear_gradient.deg +
            'deg,' +
            infor.background[infor.background.radio_val].linear_gradient.start_color +
            infor.background[infor.background.radio_val].linear_gradient.start_pointer +
            '%,' +
            infor.background[infor.background.radio_val].linear_gradient.end_color +
            infor.background[infor.background.radio_val].linear_gradient.end_pointer +
            '%)'
          : infor.background[infor.background.radio_val].color;
      return background
    },
    listArr () {
      return this.module.data.listArr;
    },
    pc_widgets_infor () {
      return this.module.data.pc_widgets_infor;
    },
    view_pattern () {
      return this.$store.state.app.view_pattern;
    },
    se_text_style() {
      let infor = this.module.data.pc_widgets_infor
      let radio_val = infor.text_style.radio_val
      let color = ''
      let pattern = infor.text_style[radio_val].sePattern;
      if (pattern === "linear_gradient") {
          color = "transparent"
        } else {
          color = infor.text_style[radio_val].selectColor
        }
      const background =
        infor.text_style[radio_val].sePattern == 'linear_gradient'
          ? 'linear-gradient(' +
            infor.text_style[radio_val].seLinear_gradient.deg +
            'deg,' +
            infor.text_style[radio_val].seLinear_gradient.start_color +
            infor.text_style[radio_val].seLinear_gradient.start_pointer +
            '%,' +
            infor.text_style[radio_val].seLinear_gradient.end_color +
            infor.text_style[radio_val].seLinear_gradient.end_pointer +
            '%)'
          : '';
          let textDecoration = 'none'
          if(radio_val === 'custom') {
            textDecoration = infor.text_style.custom.textDecoration
          }
      let obj = {
        fontFamily: infor.text_style[radio_val].fontFamily,
        fontSize: infor.text_style[radio_val].fontSize + 'px',
        fontWeight: infor.text_style[radio_val].fontWeight,
        fontStyle: infor.text_style[radio_val].fontStyle,
        color: color,
        backgroundImage: background,
        textDecoration: textDecoration
      }
      return obj
    },
    text_style() {
      let infor = this.module.data.pc_widgets_infor
      let radio_val = infor.text_style.radio_val
      let color = ''
      let pattern = infor.text_style[radio_val].pattern;
      if (pattern === "linear_gradient") {
          color = "transparent"
        } else {
          color = infor.text_style[radio_val].color
      }
      const background =
        infor.text_style[radio_val].pattern == 'linear_gradient'
          ? 'linear-gradient(' +
            infor.text_style[radio_val].linear_gradient.deg +
            'deg,' +
            infor.text_style[radio_val].linear_gradient.start_color +
            infor.text_style[radio_val].linear_gradient.start_pointer +
            '%,' +
            infor.text_style[radio_val].linear_gradient.end_color +
            infor.text_style[radio_val].linear_gradient.end_pointer +
            '%)'
          : '';
          let textDecoration = 'none'
          if(radio_val === 'custom') {
            textDecoration = infor.text_style.custom.textDecoration
          }
      let obj = {
        fontFamily: infor.text_style[radio_val].fontFamily,
        fontSize: infor.text_style[radio_val].fontSize + 'px',
        fontWeight: infor.text_style[radio_val].fontWeight,
        fontStyle: infor.text_style[radio_val].fontStyle,
        color: color,
        backgroundImage: background,
        textDecoration: textDecoration
      }
      return obj
    },
    theme_color() {
      return this.$store.state.myRender.common.theme_color;
    },
  },
  watch: {
    'listArr.content_set.custom': {
      handler (val) {
        this.formateLangData()
      },
      deep: true
    },
    // 'listArr.content_set.radio_val'(val) {
    //   this.formateLangData()
    // },
    'listArr.position'(rowType) {
      this.templet.dialog_close();
      this.$store.commit('app/set_language_position',rowType)
      this.templet.multi_language_isShow('basic_language',rowType)
    },
    'listArr.styleType'(val) {
      this.language_textReset()
    },
    'listArr.navigationItems'(val) {
      this.language_textReset()
    }
  },
  methods: {
    seLang() {
      this.$message.warning(i18n.t('widgets_basic_language_index_2556'))
      this.pcPop_isShow = false
      this.mbPop_isShow = false
      if(this.view_pattern == 'pc') {
        let dom = $(`#u${this.module.widgets_id}`).find('.languages_dropdown_panel')
        dom.css({display: 'none'})
      } else {
        let dom = $(`.layout_header`).find('.languages_dropdown_panel')
        dom.css({display: 'none'})
      }
    },
    clickOpenDialog() {
      if(this.view_pattern == 'mb') {
        if(this.listArr.styleType == 'pop') {
           this.mbPop_isShow = !this.mbPop_isShow
        } else {
          let dom = $(`#u${this.module.widgets_id}`).find('.languages_dropdown_panel')
          let display = dom.css("display")
          dom.css({display: display == 'none' ? 'block' : 'none'})
        }
      } else {
        if(this.listArr.styleType == 'pop') {
          this.pcPop_isShow = !this.pcPop_isShow
          this.getOpenLangList();
        }
      }
    },
    clickMbHeaderDialog() {
      if(this.listArr.styleType == 'pop') {
        this.mbPop_isShow = !this.mbPop_isShow
      } else {
        let dom = $(`.layout_header`).find('.languages_dropdown_panel')
        let display = dom.css("display")
				dom.css({display: display == 'none' ? 'block' : 'none'})
      }
    },
    formateLangData() {
      this.langsList = []
      const content_set = this.listArr.content_set[this.listArr.content_set.radio_val]
      const langsObj = this.$store.state.options.languageContentData
      console.log(content_set, 'content_setcontent_setcontent_setcontent_set')
      // openLangList 现在是数组格式: [{ language: "en-us", ... }]
      if (Array.isArray(this.openLangList)) {
        this.openLangList.forEach((langItem) => {
          const langKey = langItem.language
          // 从 languageContentData 获取语言名称
          const langName = langsObj[langKey] ? langsObj[langKey][0] : langKey
          this.langsList.push({
            label: content_set[langKey] ? content_set[langKey].label : langName,
            value: langKey,
            img: `https://sitecdn.71360.com/static/txys-001/image/flag/${langKey}.jpg`,
            is_hidden: langItem.is_hidden
          })
          if (this.listArr.content_set[this.listArr.content_set.radio_val][langKey]) {
            this.listArr.content_set[this.listArr.content_set.radio_val][langKey].isShow = 'true'
          }
        })
      }
      let filterArr = this.langsList.filter((item)=> item.value == this.$store.state.app.language_main)
      if(filterArr.length > 0) {
        this.selectLang = filterArr[0]
      }else{
        if(this.$store.state.app.language_main && this.listArr.content_set && this.listArr.content_set.custom){
          this.selectLang = this.listArr.content_set.custom[this.$store.state.app.language_main]
        }
      }
    },
    // 已经开通的语言
    getOpenLangList() {
      this.openLangList = [];
      getLangNavList().then((res) => {
        if (res.code === 200) {
            this.openLangList = res.data;
            this.formateLangData()
        }
      });
    },
    init_data() {
    const langsObj = this.$store.state.options.languageContentData
      for(let langKey in langsObj) {
          const content_setItem = {
            value: langKey,
              isShow: 'false',
              name: langsObj[langKey][0],
              label: langsObj[langKey][1]
          }
          // if(typeof this.listArr.content_set.custom[langKey] == 'undefined') {
            this.$set(this.listArr.content_set.custom,langKey,content_setItem);
          // }
          if(typeof this.listArr.content_set.default[langKey] == 'undefined') {
            this.$set(this.listArr.content_set.default,langKey,content_setItem);
          }
          if(typeof this.pc_widgets_infor.background == 'undefined') {
            this.$set(this.pc_widgets_infor,'background',basic_language_new_style().background);
          }
        }
    },
    language_textReset() {
      let that = this
        setTimeout(()=> {
        if(that.listArr.styleType != 'expansion' 
        && that.listArr.navigationItems == 'all' 
        && that.$store.state.app.view_pattern === 'pc') {
            const width = $(`.pc_pattern #u${that.module.widgets_id} .basic_language`).width()
            let s_multi_language_text = $(`.pc_pattern #u${that.module.widgets_id} .languages_default_item`).find('.s_multi_language_text')
            if(width < 120) {
              $(s_multi_language_text).hide()
            } else {
              if($(s_multi_language_text).css('display') == 'none') {
                $(s_multi_language_text).show()
              }
            }
          } else {
            $(`.pc_pattern #u${that.module.widgets_id} .languages_default_item`).find('.s_multi_language_text').show()
          }
        },1000)
    }
  },
  mounted() {
    let that = this
     that.language_textReset()
    $(window).on('resize', throttle(() => {
			that.language_textReset()
    }))
    window.addEventListener('refresh-language-list', this.getOpenLangList)
    if(this.$store.state.app.view_pattern === 'pc' && this.listArr.styleType == 'dropdown') {
      $(`.pc_pattern #u${that.module.widgets_id} .languages_dropdown`).hover(function(e){
        	const elementDom = $(`.pc_pattern #u${that.module.widgets_id}`)
		      const element = elementDom[0].getBoundingClientRect()
			    const itemDom = $(this).find('.languages_default_item')
			    const itemElement = itemDom[0].getBoundingClientRect()
		      const bodyWidth = document.body.offsetWidth
		      const right_num = bodyWidth - element.left
			    // 空白 文字距离
			    const empty_num = itemElement.left - element.left
		      const elementWidth = elementDom.width()
			    const width = itemDom.width()
		      let panel_left = 0
			    let triangle_left = '43%'
		      if(elementWidth > 150) {
		        panel_left = (elementWidth-150)/2
		      } else if(right_num > 150) {
		        panel_left = 0
		      } else {
            panel_left = right_num - 155
            triangle_left = empty_num + width/2 + Math.abs(panel_left) < 130 ? empty_num + width/2 + Math.abs(panel_left) + 'px' : '130px'
		      }
		     $(this).find('.languages_dropdown_panel').css({
		      left:panel_left +'px'
		     })
		     $(this).find('.dropdown_panel_triangle').css({
		      left:triangle_left
		     })
      })
    }
  },
  beforeDestroy() {
    window.removeEventListener('refresh-language-list', this.getOpenLangList)
  },
  created() {
    this.init_data()
    this.getOpenLangList()
    this.listArr.position = this.module.rowType
    this.$store.commit('app/set_language_position',this.module.rowType)
  }
};
</script>

<style lang="scss" scoped type="text/css">
@import "src/css/components/basic_language";
.jz_web_col {
    position: relative;
    min-height: 30px;
    box-sizing: border-box;
    font-size: 0;
}
.s_multi_language_wrap {
    min-width: 150px;
    width: 100%;
    position: relative;
    text-align: center;
    -webkit-tap-highlight-color: transparent;
}
.s_multi_language_text {
    font-size: 14px;
    vertical-align: middle;
    color: #333;
    -webkit-background-clip: text;
}
.languages_dropdown {
    position: relative;
}
.s_multi_language_wrap {
    position: relative;
    text-align: center;
    -webkit-tap-highlight-color: transparent;
}
.languages_default_item {
    line-height: 60px;
    height: 60px;
    cursor: pointer;
    text-align: center;
    // display: flex;
    // justify-content: center;
    // align-items: center;
}
.s_multi_language_icon+.s_multi_language_text {
    margin-left: 12px;
}
.s_multi_language_dropdown_svg {
    color: #666;
    vertical-align: middle;
    margin-left: 5px;
    transition: transform .3s ease;
    display: inline-block;
}
.languages_dropdown.no_text .languages_dropdown_panel {
    width: 150px;
    // margin-left: -75px;
}
.languages_dropdown.no_text .languages_dropdown_item {
    display: inline-block;
    vertical-align: middle;
    margin: 8px;
}
.languages.languages_dropdown:hover .s_multi_language_dropdown_svg {
  transform: rotate(180deg);
}
.s_multi_language_icon {
    display: inline-block;
    vertical-align: middle;
    width: 24px;
    min-width: 24px;
    height: 18px;
}
.languages_dropdown_item {
    margin: 20px 0;
}
a, a:hover {
    text-decoration: none;
}
.languages_dropdown_panel {
    position: absolute;
    width: 150px;
    text-align: left;
    background-color: #fff;
    border: 1px solid #ebebeb;
    border-radius: 2px;
    z-index: 1500;
    box-sizing: border-box;
    // margin-left: -74px;
    list-style: none;
    display: none;
}
.pc_pattern .languages_dropdown_panel.top {
    top: 50px;
}
.languages_dropdown_panel.top .dropdown_panel_triangle:after{
    position: absolute;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    top: -6px;
    margin-left: -8px;
    border-top-width: 0;
    border-bottom-color: var(--background);
    content: " ";
    border-width: 8px;
}
.languages_dropdown_panel.top .dropdown_panel_triangle {
    position: absolute;
    display: block;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    left: 43%;
    margin-right: 4px;
    border-top-width: 0;
    border-bottom-color: #ebebeb;
    border-width: 8px;
    filter: drop-shadow(0 2px 12px rgba(0,0,0,.03));
    top: -17px;
}
.languages_dropdown_panel.bottom .dropdown_panel_triangle:after{
    position: absolute;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    bottom: -6px;
    margin-left: -8px;
    border-bottom-width: 0;
    border-top-color: var(--background);
    content: " ";
    border-width: 8px;
}
.languages_dropdown_panel.bottom .dropdown_panel_triangle{
    position: absolute;
    display: block;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    left: 43%;
    margin-right: 4px;
    border-bottom-width: 0;
    border-top-color: #ebebeb;
    border-width: 8px;
    filter: drop-shadow(0 2px 12px rgba(0,0,0,.03));
    bottom: -17px;
}

.languages_expansion {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    padding-left: 10px;
}
.languages_expansion .language_item {
    margin: 5px 0;
}
.language_item_wrapper {
    display: flex;
    align-items: center;
}
.languages_expansion .s_multi_language_icon+.s_multi_language_text {
    margin-left: 8px;
    text-align: left;
}
.lan_list .s_multi_language_text, .languages_dropdown_panel .s_multi_language_text, .languages_expansion .s_multi_language_text {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    line-height: 17px;
    font-size: 14px;
    vertical-align: middle;
    color: #333;
}
.languages_expansion .language_item_after {
    width: 1px;
    height: 18px;
    background: #b68686;
    opacity: .2;
    margin: 0 15px;
}
.c_popup{
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9034;
  text-align: center;
}
.c_popup:after {
    content: "";
    height: 100%;
}
.c_popup_layout {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.6);
}
.c_popup_main {
    position: relative;
    padding: 40px 0;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 0 10px rgba(0,0,0,.15);
}
.c_popup:after, .c_popup_main {
    display: inline-block;
    vertical-align: middle;
}
.c_popup_content {
    padding: 23px 60px 0;
    font-size: 18px;
    line-height: 22px;
    word-break: break-word;
}
.multi_language_panel {
    width: 440px;
    margin: -63px 0 0 -60px;
}
.multi_language_panel .lan_title {
    height: 50px;
    line-height: 50px;
    text-align: left;
    padding-left: 30px;
    width: 500px;
    border-bottom: 1px solid #f0f0f0;
    box-sizing: border-box;
    font-size: 14px;
}
.multi_language_panel .lan_container {
    width: 500px;
}
.multi_language_panel .lan_lists {
    display: flex;
    flex-wrap: wrap;
    padding: 32px 12px 0px 24px;
    text-align: left;
    max-height: 280px;
    overflow-x: hidden;
    overflow-y: auto;
    scrollbar-width: thin;
}
.multi_language_panel .lan_list {
    display: inline-block;
    width: 150px;
    text-align: left;
    margin-bottom: 24px;
    cursor: pointer;
}
.c_popup_close {
    position: absolute;
    right: 30px;
    top: 20px;
    cursor: pointer;
    color: #666;
    font-size: 12px;
}
.multi_Language_mobi_panel {
    display: block;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 9100;
}
.multi_Language_mobi_panel .lan_layout {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.6);
}
.multi_Language_mobi_panel .lan_mobi_lists {
    justify-content: space-around;
    max-width: 100%;
    z-index: 1;
    position: absolute;
    top: auto;
    left: 0;
    bottom: 0;
    padding: 0;
    padding-bottom: 0;
    width: 100%;
    vertical-align: middle;
    box-shadow: 0 0 20px rgba(0,0,0,.15);
    background: #fff;
    white-space: normal;
    max-height: 300px;
    overflow-y: auto;
}
.multi_Language_mobi_panel .lan_mobi_list {
    height: 50px;
    line-height: 50px;
    text-align: left;
    box-sizing: border-box;
    padding: 0 30px;
    border-bottom: 1px solid #f0f0f0;
}
.multi_Language_mobi_panel .lan_mobi_list a {
    width: 100%;
    display: inline-block;
    -webkit-tap-highlight-color: transparent;
}
.lan_mobi_list .s_multi_language_text {
    max-width: calc(100% - 42px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
}
.mb_icon {
    width: 24px;
    height: 24px;
    position: absolute;
    right: 20px;
    top: 12px;
    z-index: 1000;
}
.mb_pattern .languages_dropdown_panel.top {
    right: 0 !important;
    margin-left: 38px !important;
    top: 48px;
}
.mb_pattern .languages_dropdown_panel.top .dropdown_panel_triangle {
    left: auto !important;
    right: 20px !important;
}
.languages_dropdown_panel.bottom {
    bottom: 50px !important;
}

.basic_language .tooptipPart {
  display: none;
  position: absolute;
  z-index: 100;
  top: 0 !important;
  right: 0 !important;
  height: 28px;
  line-height: 28px;
  background: rgba(46, 52, 59, 0.88);
  font-size: 0;
  font-family: Arial, Helvetica, sans-serif;
  vertical-align: middle;
  white-space: nowrap;
}
.tooptipPart:hover {
  display: block;
}
.pc_pattern .dropdown .languages_dropdown:hover .languages_dropdown_panel {
    display: block !important;
  }
  .languages_dropdown_content {
    max-height: 500px;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0 15px 0 12px;
    margin-top:10px;
  }
  // .basic_language .lan_lists::-webkit-scrollbar
.basic_language .languages_dropdown_content::-webkit-scrollbar{
    width: 0;
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_language/index.vue